import SvgSettings from "./settings";

export default SvgSettings;